<template>
  <div class="popup-wrapper">
    <div class="popup-overlay" @click="$emit('closePopup')"></div>
    <div class="popup popup--request-contact" v-if="step === 1" style="width: 1000px">
      <button class="popup-close" @click="$emit('closePopup')"></button>

      <div class="form-block">
        <div class="form-block-inner">
          <RichEditor :initValue="data.message.content" @change="val => data.message.content = val" :isClipboardEnabled="true" placeholder="Start typing..."></RichEditor>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RichEditor from "@/components/general/RichEditor";

export default {
  name: "PopupShareByEmail",
  components: {RichEditor},
  props: ['data'],
  data () {
    return {
      step: 1,
      validationObject: {
        subject: false,
        content: false,
      },
      error: false
    }
  },
  methods: {
    // trackSendContactRequestSolution () {
    //   this.$gtag.event('SendContactRequestSolution', {
    //     'event_category': this.$store.getters.company.name,
    //     'event_label': this.$route.path,
    //     'value': this.data.message.subject
    //   })
    // },
    copyToClipboard() {
      const textarea = document.createElement('textarea');
      document.body.appendChild(textarea);
      textarea.value = this.data.message.content;
      textarea.select();
      textarea.setSelectionRange(0, 99999);
      document.execCommand('copy');
      document.body.removeChild(textarea);
    },
    downloadEmail() {
      let email = `To:
Subject: ${this.data.message.subject}
X-Unsent: 1
Content-Type: text/html; charset=UTF-8

<html>
<head>
<style>
  h2 {
    margin: 0;
  }

  h3 {
    margin-bottom: 40px;
  }

  ul {
    margin: 0 0 0 17px;
  }

  li + li {
      margin-top: 8px;
    }

  p + h2,
  ul + h2 {
    margin-top: 54px;
  }

  p + h3,
  ul + h3 {
    margin-top: 40px;
  }

  h2 + p {
    margin-top: 40px;
  }

  h2 + ul {
    margin-top: 16px;
  }

  h2 + h3 {
    margin-top: 16px;
  }

  .video-box {
    max-width: 640px;
  }
  .medium-insert-images figure {
    display: flex;
    justify-content: center;
  }

  p a {
    color: #0058AB;
  }
  p:hover, a:hover {
    color: #272936;
  }

  ul {
    list-style: disc;
  }

  .lead {
    margin-bottom: 40px;
  }

  .article-flex {
    display: flex;
    margin: 40px -15px 0;
    flex-wrap: wrap;
  }
  .article-number {
      margin-bottom: 40px;
      padding: 0 15px;
      width: 33.33333%;
    }

    .article-number-value {
      display: block;
      margin-bottom: 8px;
      font-weight: 700;
      font-size: 64px;
      color: #0058AB;
    }

    .article-number-label {
      font-weight: 500;
      font-size: 28px;
    }
</style>
</head>
<body>
<div class="main">
    <div class="Content">
        <div>${this.data.message.content}</div>
    </div>
</div>
</body>
</html>
`
        const url = window.URL.createObjectURL(new Blob([email], {type: 'text/plain'}));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute('download', `${this.data.message.subject}.eml`);
        document.body.appendChild(link);
        link.click();
    },
  }
}
</script>
